import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { closeCustomModal, openCustomModal } from "components/custom/modals";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchApiLogs
} from "actions/apiInfoActions";

class LogsList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.props.fetchApiLogs();
    }

    componentWillUnmount() {
        this.props.fetchApiLogs(true);
    }

    render () {
        const {
            logs,
            loading
        } = this.props;

        // "path": "D:\\Work\\CounterIntel\\CounterIntelligence\\server\\CIRS.Api\\logs",
        // "name": "cirs-api-1.3.8-20191207.log",
        // "modifiedAt": "2019-12-07T15:57:04.9360703-05:00",
        // "createdAt": "2019-12-07T15:48:19.4930167-05:00",
        // "size": 10847

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Name",
                accessor: "name",
                id: "name",
            },
            {
                Header: "Size",
                accessor: "size",
                id: "size",
            },
            {
                Header: "Path",
                accessor: "path",
                id: "path",
            },
            {
                Header: "Created At",
                accessor: "createdAt",
                id: "createdAt",
                Cell: ({ original }) => moment(original.createdAt).format(this.dateFormat)
            },
            {
                Header: "Modified At",
                accessor: "modifiedAt",
                id: "modifiedAt",
                Cell: ({ original }) => moment(original.modifiedAt).format(this.modifiedAt)
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <Link to={`/logs/${original.name}`} className="btn btn-sm btn-primary">
                        <FontAwesomeIcon icon="eye" title="Update" />
                    </Link>
                ),
                filterable: false,
                width: 100
            },
        ];

        return (
            <div className="px-5">
                <div className="dashboard">
                    <h3 className="mb-4">
                        Logs
                    </h3>

                    <ReactTable
                        data={logs}
                        headerClassName="table-header"
                        columns={columns}
                        defaultPageSize={20}
                        pageSizeOptions={[10, 20, 50, 100]}
                        resizable
                        className="-striped -highlight"
                        loading={loading}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        defaultSorted={[
                            {
                                id: "jobNumber",
                                desc: false
                            }
                        ]}
                        defaultFiltered={[
                            {
                                id: "isInactive",
                                value: "YES"
                            }
                        ]}
                        getNoDataProps = {() => ({
                            style: {
                                zIndex: 0
                            }
                        })}
                        style={{
                            height: "calc(100vh - 200px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

LogsList.propTypes = {
    fetchApiLogs: PropTypes.func.isRequired,

    logs: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    logs: state.apiInfo.logs,
    loading: state.globalFormErrors.loading
});

const mapStateToDispatch = dispatch => ({
    fetchApiLogs: bindActionCreators(fetchApiLogs, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(LogsList);
